import { FC } from 'react'
import { Group as GroupType } from '../types'
import { Item, Props as ItemProps } from './Item'
import { Label } from './Label'
import { IconButton } from 'components/buttons'
import { faAngleDown, faAngleUp } from '@fortawesome/pro-regular-svg-icons'
import { useTranslation } from 'react-i18next'

export type GroupProps = Omit<GroupType, 'id'> & {
  collapsed: boolean
  onCollapse: () => void
  onExpand: () => void
  onItemClick: ItemProps['onItemClick']
}

export const Group: FC<GroupProps> = ({
  collapsed,
  name,
  onCollapse,
  onExpand,
  onItemClick,
  subGroups,
}) => {
  const { t } = useTranslation()
  const toggle = collapsed ? onExpand : onCollapse

  return (
    <section className="flex-col mt-2" key={name}>
      <div className="flex flex-row gap-2 pb-2 items-center">
        <IconButton
          className="shrink-0 bg-neutral-200 w-6 h-6 text-neutral-600 hover:bg-neutral-300"
          icon={collapsed ? faAngleDown : faAngleUp}
          onClick={toggle}
          srOnlyLabel={
            collapsed
              ? t('features.timeLogging.taskSelection.expand')
              : t('features.timeLogging.taskSelection.collapse')
          }
        />
        <button
          className="flex flex-row items-center min-w-0 text-left"
          onClick={toggle}
        >
          <Label
            content={name}
            count={subGroups.flatMap((s) => s.items).length}
          />
        </button>
      </div>
      {(collapsed ? [] : subGroups).map(({ name, displayPath = [], items }) => (
        <div key={`${name ?? ''}-${displayPath.join('---')}`} className="mb-2">
          {name && (
            <h3 className="text-xs font-medium text-neutral-500">{name}</h3>
          )}
          {items.map((item, index) => (
            <Item
              key={item.task.id}
              item={item}
              path={index === 0 ? displayPath : []}
              onItemClick={onItemClick}
            />
          ))}
        </div>
      ))}
    </section>
  )
}
